import { useEffect } from "react";
import { useWebSocket } from "./WebSocketProvider";

const TopicSubscriber = ({ subTopic, onMessageReceived }) => {
    const { subscribe, unsubscribe } = useWebSocket();

    useEffect(() => {
        subscribe(subTopic, onMessageReceived);
        console.log("Subscribed to " + subTopic);

        return () => {
            unsubscribe(subTopic, onMessageReceived);
            console.log("Unsubscribed from " + subTopic);
        };
    }, [subTopic]);

    return null; // Non renderizza nulla
};

export default TopicSubscriber;